import { render, staticRenderFns } from "./DeleteShooting.vue?vue&type=template&id=b81d3a16"
import script from "./DeleteShooting.vue?vue&type=script&lang=js"
export * from "./DeleteShooting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports